/**
 * UI-related translations for Chinese (Simplified) language
 * This file contains translations for common UI elements
 */
export default {
  startPanel: {
    copyLink: '复制连结',
    discord: 'Discord',
    leaveGame: '离开游戏',
    joinGame: '加入游戏',
    lockGame: '锁定游戏',
    unlockGame: '解锁游戏',
    startGame: '开始游戏',
    options: '选项',
  },
  onlineStatus: {
    connecting: '连线中...',
    connected: '上线',
    error: '连线失败',
  },
  profile: {
    username: '用户名',
    stats: '统计',
    logout: '退出登录',
    language: '语言',
    hideSpoilersHint: '隐藏剧透',
    hideIndexHint: '隐藏历史索引',
    animeMode: '动漫模式',
    update: '更新',
    colorTheme: '色彩主题',
    darkTheme: '深色主题',
    lightTheme: '浅色主题',
    profile: '个人资料',
    settings: '设置',
    change: '更改',
    changePassword: '更改密码',
  },
  breadCrumbs: {
    merlin: '梅林',
    merlin_pure: '终极梅林',
    guinevere: '女皇',
    percival: '派西维尔',
    lovers: '恋人',
    troublemaker: '麻烦友',
    servant: '仆人',
    lancelots: '兰斯洛特',
    mordred: '莫德雷德',
    trickster: '骗子',
    morgana: '莫甘娜',
    revealer: '被揭示者',
    oberon: '奥伯伦',
    lunatic: '疯子',
    brute: '野蛮人',
    witch: '巫婆',
    minion: '士兵',
    cleric: '牧师',
    wiki: '维基',
    expansions: '插件',
    roles: '角色',
    lady: '湖中仙女',
    lady_sea: '海中仙女',
    plot_cards: '情节卡',
    excalibur: '神剑',
    rules: '规则',
  },
  hostMenu: {
    host: '房主',
    hostPanel: '房主面板',
    endRestartGameHint: '开始投票,决定游戏结束或重新开始',
    endGame: '游戏结束',
    restartGame: '重新开始游戏',
    shuffle: '随机换位',
    shuffleHint: '随机调整大厅中玩家的位置',
  },
  cardsInfo: {
    cards: '卡牌',
    usedCards: '已使用的卡牌',
    remainingCards: '剩余卡牌',
    leadToVictory: '引领胜利',
    leadToVictoryHint: '在队伍选择前成为领袖',
    ambush: '埋伏',
    ambushHint: '揭示一张任务卡的结果',
    kingReturns: '王者归来',
    kingReturnsHint: '取消已批准的任务并将领导权移交给下一位玩家',
    restoreHonor: '恢复荣誉',
    restoreHonorHint: '从任意玩家处拿取情节卡',
    charge: '指控',
    chargeHint: '强制玩家公开投票',
    showNature: '展现真我',
    showNatureHint: '向另一玩家展示你的忠诚',
    areYouTheOne: '天命之人',
    areYouTheOneHint: '检查相邻玩家的忠诚',
    weFoundYou: '找到你了',
    weFoundYouHint: '强制一名玩家正面打出任务卡',
    showStrength: '展示力量',
    showStrengthHint: '领袖向玩家揭示其忠诚',
  },
  avatars: {
    modalHeader: '选择头像',
    servantHint: '默认头像',
    lady_of_lakeHint: '颁发给2025年注册的用户',
    mysteryHint: '授予發現網站上秘密的用戶',
    merlin_pureHint: '颁发给帮助项目反馈/帮助寻找错误的用户',
    'anime/merlin_pureHint': '颁发给在GitHub上对项目代码做出任何贡献的用户',
    'anime/witchHint': '授予在任何角色上获得第一名评分的玩家',
  },
  spoiler: {
    spoiler: '劇透',
    spoilerHint: '該內容隱藏在劇透下方,因為它包含其他玩家不知道的訊息',
  },
  previewLink: {
    'Minions of Mordred(*)': '莫德雷德的爪牙(*)',
    Minions: '士兵',
  },
  chartStats: {
    countPlayer: '{playerCount} 名玩家',
    evilWinrate: '黑暗阵营胜率',
    goodWinrate: '光明阵营胜率',
    winrateByTeamSize: '根据队伍规模的胜率',
    halfWinrate: '50% 胜率',
  },
  inGame: {
    sendTeam: '发送组队',
    approve: '同意',
    reject: '拒绝',
    success: '成功',
    fail: '失败',
    checkLoyalty: '检查忠诚度',
    giveExcalibur: '给予神剑',
    skipExcalibur: '跳过神剑',
    useExcalibur: '使用神剑',
    useWitchAbility: '隐藏任务',
    skipWitchAbility: '跳过',
    giveCard: '给卡',
    takeLead: '成为领袖',
    skip: '跳过',
    useCard: '使用{cardName}',
    skipCard: '跳过{cardName}',
    selectPlayer: '选择一名玩家',
    selectSinglePlayer: '请只选择一名玩家',
    cannotSelectSelf: '你不能选择自己',
    takeCard: '拿取卡牌',
    selectCard: '选择一张卡牌',
    noAvailableCards: '没有可用的卡牌',
    revealLoyalty: '揭示忠诚',
  },
};
